import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "@/admin/adminApi";
import AdminLayout from "@/admin/AdminLayout";

const CARDS = [
  ["pages", "Pages", "/admin/pages"],
  ["services", "Services", "/admin/services"],
  ["industries", "Industries", "/admin/industries"],
  ["news_posts", "News posts", "/admin/news"],
  ["projects", "Projects", "/admin/projects"],
  ["gallery_items", "Gallery items", "/admin/gallery"],
  ["contact_new", "Unread messages", "/admin/contact-submissions"],
  ["contact_total", "Total messages", "/admin/contact-submissions"],
];

export default function DashboardPage() {
  const [summary, setSummary] = useState({});
  useEffect(() => {
    adminApi.get("/summary").then((r) => setSummary(r.data)).catch(() => {});
  }, []);
  return (
    <AdminLayout title="Dashboard">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="admin-dashboard">
        {CARDS.map(([key, label, href]) => (
          <Link
            key={key}
            to={href}
            data-testid={`dash-${key}`}
            className="bg-white border border-mist-soft rounded-md p-6 hover:border-mist-gold/60 transition"
          >
            <div className="text-[11px] uppercase tracking-[0.22em] text-mist-navy/60 font-semibold">{label}</div>
            <div className="mt-3 font-display text-3xl text-mist-navy">
              {summary[key] ?? "–"}
            </div>
          </Link>
        ))}
      </div>
    </AdminLayout>
  );
}
